<div id="video-thumbnails-container">
  <div class="video-thumbnail" (click)="onVideoClicked(video)">
    <mat-icon>play_circle</mat-icon>
    <img [src]="video.encodings[0].thumbnails[0].file" />
  </div>
</div>
